import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import AddEditAdForm from './AddEditAdForm';
import { useMutation } from 'react-query';
import { createAd } from '../../api/ad';

const NewAdDialog = ({ onClose, refetch }) => {
  const { mutate, isLoading } = useMutation({
    mutationFn: createAd,
    onSuccess: () => {
      refetch();
      onClose();
    },
  });

  const onSubmit = formData => {
    mutate(formData);
  };

  return (
    <Dialog open fullWidth maxWidth="lg" onClose={onClose}>
      <DialogTitle>Нове оголошення</DialogTitle>
      <DialogContent>
        <AddEditAdForm
          onSubmit={onSubmit}
          onCancel={onClose}
          isLoading={isLoading}
        ></AddEditAdForm>
      </DialogContent>
    </Dialog>
  );
};

export default NewAdDialog;
